import { Card, CardContent } from "../ui/card";
import { BookOpen, ExternalLink } from "lucide-react";

const Thesis = () => (
  <section className="transition-opacity duration-300">
    <h2 className="text-3xl font-bold mb-8 text-[#57068C]">My Thesis</h2>
    <Card className="hover:shadow-xl transition-shadow duration-300">
      <CardContent className="p-8">
        <div className="flex flex-col md:flex-row gap-8">
          <div className="flex-shrink-0 w-full md:w-64 flex flex-col items-center gap-4">
            <img
              src="/images/thesis-cover.jpg"
              alt="Thesis cover page"
              className="w-full rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
            />
          </div>
          <div className="flex-1">
            <h3 className="text-2xl font-bold mb-4 text-gray-900">
              Psilocybin-assisted therapy as a pharmacological invervention for
              depresssion amd trauma-related disorders through modulation of the
              Default Mode Network
            </h3>
            <p className="text-lg text-gray-600 mb-6">
              At the heart of the research lies the Default Mode Network (DMN)—a
              critical brain system implicated in self-reflection, memory, and
              identity—which is often disrupted in individuals suffering from
              PTSD and depression. This thesis makes the compelling case that
              psilocybin, the active compound in psychedelic mushrooms, has the
              power to therapeutically modulate this network. Drawing from
              decades of neuroscience, psychology, and cutting-edge clinical
              research, the thesis presents psilocybin not as a mind-altering
              escape, but as a precise neurochemical intervention capable of
              restoring cognitive balance, reducing emotional distress, and
              reigniting the brain’s capacity for healing.
            </p>
            <p className="text-lg text-gray-600 mb-6">
              Rich in scientific rigor yet deeply human in purpose, this work
              invites clinicians, researchers, and curious minds alike to
              reconsider what effective trauma therapy can look like. With
              mental illness affecting 1 in 8 people worldwide—and standard
              treatments failing far too many—this thesis lights a hopeful path
              forward.
            </p>
            <p className="text-lg text-gray-600 mb-6">
              If you’re fascinated by the mind, moved by the suffering caused by
              trauma, and ready to explore revolutionary approaches to healing,
              please read this thesis.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  </section>
);

export default Thesis;
